import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
  ParagraphEntity,
} from '@uncinc/react-drupal-core/types';

import './style.scss';

interface ParagraphMediaFilteredProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphEntity>;
}

const ParagraphMediaFiltered: React.FC<ParagraphMediaFilteredProps> = () => (
  <div className="Paragraph ParagraphMediaFiltered">
    <View
      className="row"
      id="media_filtered"
      display="media_filtered"
      storageType="url"
      withProvider
    />
  </div>
);

export default ParagraphMediaFiltered;
